import getRequest from '../../../../getRequest';

/**
 * Get all Site Product Types for the given site id from PRISM db.
 *
 * @param {number} siteId
 * @returns {[
 *   {
 *     productTypeId: number,
 *     name: string
 *   }
 * ]}
 */
function getProductTypes(siteId) {
  const endpoint = `/oc-product/v1/sites/${siteId}/product-types`;

  return new Promise((resolve, reject) => {
    getRequest(endpoint, 'Get Product Types')
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}

export default getProductTypes;
